import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

const PRESETS = {
  user: ["Thank you, that helped", "I needed that today", "Means a lot 💜", "Can we talk soon?"],
  supporter: ["Proud of you", "Thinking of you", "I'm here for you", "You've got this 💪"],
};

export const QuickReplies = ({ noteId, onPick, me = "user" }) => {
  const [ai, setAi] = useState([]);
  const [busy, setBusy] = useState(false);

  const suggest = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/supporter-notes/${noteId}/suggestions`);
      setAi(data.suggestions);
    } catch (e) {
      toast.error(errMsg(e, "Suggestions are unavailable right now"));
    } finally {
      setBusy(false);
    }
  };

  const chip = "text-xs rounded-full px-3 py-1.5 transition-transform hover:scale-105";
  return (
    <div className="flex flex-wrap gap-1.5 pt-1" data-testid={`quick-replies-${noteId}`}>
      {PRESETS[me].map((t, i) => (
        <button key={t} type="button" onClick={() => onPick(t)} className={`${chip} mm-soft`} data-testid={`quick-reply-${noteId}-${i}`}>{t}</button>
      ))}
      {ai.map((t, i) => (
        <button key={t} type="button" onClick={() => onPick(t)} className={`${chip} border border-mm-primary text-mm-primary`} data-testid={`ai-reply-${noteId}-${i}`}>{t}</button>
      ))}
      {me === "user" && !ai.length && (
        <button type="button" onClick={suggest} disabled={busy} className={`${chip} border border-dashed border-mm-primary text-mm-primary inline-flex items-center gap-1`} data-testid={`ai-suggest-${noteId}`}>
          {busy ? <Loader2 size={12} className="animate-spin" /> : <Sparkles size={12} />}Suggest replies
        </button>
      )}
    </div>
  );
};
